import { render, staticRenderFns } from "./Curriculum.vue?vue&type=template&id=ebcea4fe&scoped=true"
import script from "./Curriculum.vue?vue&type=script&lang=js"
export * from "./Curriculum.vue?vue&type=script&lang=js"
import style0 from "./Curriculum.vue?vue&type=style&index=0&id=ebcea4fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcea4fe",
  null
  
)

export default component.exports